import React from "react"
import { defaultMarkdownElements } from "#/services/markdown"
import type { BlockQuoteNode } from "../renderer/types"
import { ContentList } from "./content-item"
import { backgroundColorToTileProps } from "#/services/contentful/mappings/backgroundColorToTileProps"

export function BlockQuoteContent({ content }: { content: BlockQuoteNode }) {
  const tileProps = content.backgroundColor ? backgroundColorToTileProps[content.backgroundColor] ?? {} : {}

  return (
    <defaultMarkdownElements.blockquote.component {...defaultMarkdownElements.blockquote.props} {...tileProps}>
      <ContentList contents={content.content} />
    </defaultMarkdownElements.blockquote.component>
  )
}
